import { CARD_VIEW } from 'site-modules/shared/constants/lead-form/lead-form-params';

export const getCardView = ({ isUsedSrpDealCheck, isInventoryDeal }) => {
  if (isUsedSrpDealCheck || isInventoryDeal) {
    return CARD_VIEW.DEALER_VIN_CHECK_AVAILABILITY;
  }

  return CARD_VIEW.DEALER_VIN;
};
